// removed by extract-text-webpack-plugin
module.exports = {"fullHeight":"_3cthkTBtwMU5nkUf3Q8WwM","headerContainer":"RQ8QXF3zgtfbQyt0kcBtV","fullWidth":"_2yiJvyC_tiO10Rl0-ZBNLh","navUl":"_2av7sr59rT-YnGTc9ak4Ph","linkStyle":"gqrY353k51fUTPkos6y24","linkBorder":"_38VHKORxUq1r7S1CP9MjLy","navIcon":"_1zZL_XwZpDYM8yrSd07aOy","navIconText":"xJYoUDBi_dVWx4Z2k-K65","iconHead":"_1GJ0KBHCmBPC9o0XvbMMPu","iconHeadWrapper":"_2ocFc8jnOyK28YGG0OR07i","collapseMenu":"_1dwCf7VGeXtko64plA0-8v","menu":"_2YMJGVbIj1IoyI79-7AZ07","menuButton":"_128igGt1QjjRPYxTBO5pNr","iconLogOut":"_3mSiVJldcaalZRPO1aytzm"};


//////////////////
// WEBPACK FOOTER
// ./components/Navigation/style.less
// module id = 1166
// module chunks = 0